import * as PropTypes from 'prop-types';
import * as React from 'react';
import Product from './product';
import PriceFieldWithCurrency from '../../../shared/price_field_with_currency';
import OfferItem from './offer_item';

class OfferItemView extends React.Component {
  constructor(props) {
    super(props);
    this.removeOfferItem = this.removeOfferItem.bind(this);
    this.setPrice = this.setPrice.bind(this);
    this.setShippingPrice = this.setShippingPrice.bind(this);
  }

  setPrice(e) {
    this.props.setPrice({ listingId: this.listing.id, price: e.target.value });
  }

  setShippingPrice(e) {
    this.props.setShippingPrice({ listingId: this.listing.id, shippingPrice: e.target.value });
  }

  removeOfferItem() {
    this.props.onRemove(this.listing.id);
  }

  get offerItem() {
    return this.props.offerItem;
  }

  get listing() {
    return this.offerItem.listing;
  }

  get listingCurrency() {
    return this.offerItem.currency;
  }

  get initialOfferPrice() {
    return this.offerItem.price;
  }

  get initialOfferShippingPrice() {
    return this.offerItem.shippingPrice;
  }

  render() {
    return (
      <div>
        <a className="email-offer__item-close" onClick={this.removeOfferItem} />

        <Product product={this.listing} initialOfferPrice={this.initialOfferPrice} />

        <div className="email-offer__item-fields">
          <div className="email-offer__item-field">
            <label>{I18n.t('emailOffers.offerItem.price')}</label>
            <PriceFieldWithCurrency
              defaultValue={this.initialOfferPrice}
              currency={this.listingCurrency}
              showCurrencyCode
              onChange={this.setPrice}
              name={`offer_item_price_${this.listing.id}`}
            />
          </div>
          <div className="email-offer__item-field">
            <label>{I18n.t('emailOffers.offerItem.shippingPrice')}</label>
            <PriceFieldWithCurrency
              defaultValue={this.initialOfferShippingPrice}
              currency={this.listingCurrency}
              showCurrencyCode
              onChange={this.setShippingPrice}
              name={`offer_item_shipping_price_${this.listing.id}`}
            />
          </div>
        </div>

      </div>
    );
  }
}

OfferItemView.propTypes = {
  offerItem: PropTypes.instanceOf(OfferItem),
  onRemove: PropTypes.func.isRequired,
  setPrice: PropTypes.func.isRequired,
  setShippingPrice: PropTypes.func.isRequired,
};

export default OfferItemView;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/email_offers/offer_item_view.jsx